import type { NativeExtensions } from '@wix/thunderbolt-components-native'
import { compCssMappersWithModesAndVariants } from './compCssMappersWithModesAndVariantsCompNode'
import type { RunAndReportFn } from '@wix/thunderbolt-state-manager'

export const compSelectorToCssMappers = (nativeExtensions: NativeExtensions, runAndReport: RunAndReportFn) => {
	return compCssMappersWithModesAndVariants(nativeExtensions, 'compSelectorToCssMappers', runAndReport)
}
